import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from '@/components/layout/AppShell';
import { PlaceholderPage } from '@/pages/PlaceholderPage';
import { ApprovalGate } from '@/features/approval/components/ApprovalGate';
import { ApprovalPage } from '@/features/approval/pages/ApprovalPage';

// /approvazione sits OUTSIDE the gate — it must be reachable for any
// authenticated user (PENDING_APPROVAL / REJECTED / NO_MEMBERSHIP) and
// for ACTIVE users that hit the URL directly (the page redirects them
// to "/"). The operational subtree lives inside <ApprovalGate /> so
// only ACTIVE memberships render the AppShell.
export function AppRoutes(): JSX.Element {
  return (
    <Routes>
      <Route path="/approvazione" element={<ApprovalPage />} />
      <Route element={<ApprovalGate />}>
        <Route element={<AppShell />}>
          <Route index element={<PlaceholderPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
